import styles from "./checkbox.module.scss";
import { Box as MantineBox, Input as MantineInput, Text as MantineText } from "@mantine/core";
import { IconEye, IconEyeOff } from "@tabler/icons-react";

type Props = {
  selected?: Filter;
  option: Filter;
};
const Checkbox = ({ selected, option }: Props) => {
  return (
    <MantineInput.Label className={styles.checkBoxContainer}>
      <MantineInput
        type="checkbox"
        name="checkbox-checked"
        checked={!!selected}
        data-state={selected?.state}
        readOnly
      />
      <MantineText
        span
        className={styles.checkmark}
        data-state={selected?.state}
        aria-hidden="true"
      >
        {selected?.state === "exclude" ? <IconEyeOff /> : selected ? <IconEye /> : null}
      </MantineText>
      <MantineBox className={styles.labelText}>&nbsp;&nbsp;{option.label}</MantineBox>
    </MantineInput.Label>
  );
};

export default Checkbox;
